<template>
    <div class="form-input">
        <label v-if="label" :for="id ?? name" class="input-label" v-html="label"> </label>
        <div class="form-element-wrap">
            <input
                :id="id ?? name"
                class="form-element"
                :class="{ 'has-error': errorMessage }"
                :type="type ?? 'text'"
                :name="name"
                :placeholder="placeholder"
                :value="modelValue"
                v-bind="$attrs"
                @input="(event) => emit('update:modelValue', (event.target as HTMLInputElement).value)"
                @focus="() => emit('focus')"
                @blur="() => emit('blur')"
            />
            <div
                v-if="errorMessage"
                class="error-message"
                :class="{ 'is-clickable': errorClickable }"
                @click="errorClickable && emit('error-click')"
            >
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
// Disable default root-element inheritance
defineOptions({
    inheritAttrs: false,
});
defineProps<{
    id?: string;
    name: string;
    label?: string;
    type?: string;
    placeholder?: string;
    modelValue?: string;
    errorMessage?: string | Ref<string>;
    errorClickable?: boolean;
}>();

const emit = defineEmits<{
    (e: 'update:modelValue', modelValue: any): void;
    (e: 'focus'): void;
    (e: 'blur'): void;
    (e: 'error-click'): void;
}>();
</script>

<style lang="postcss" scoped>
.error-message.is-clickable {
    @apply underline cursor-pointer;
}
</style>
